export default __webpack_public_path__ + "fa3f3dbf74256ed4e35334ad8a5cc662.png";